import { getMapData, getMapFilters } from "../../services/TenantServices";
import { SYSTEM_NOT_AVAILABLE } from "./MapConstants";

const ALERT_LEVEL = {
  CRITICAL : "critical",
  CRITICAL_CODE: 2,
  WARNING  : "warning",
  WARNING_CODE:1,
  NORMAL    : "normal",
  NORMAL_CODE : 0,
  CRITICAL_WARNING : "criticalWithWarning",
};

export const getMapFiltersData = async () => {
  const response =  await getMapFilters();
  return response;
};

export const getMapListData = async (countryId,tenantId,siteId) => {
  let response = await getMapData(countryId,tenantId,siteId);
  return response;
};

export const getDropdownOptions = (countries, defaultCountryId) => {
  let countryOptions = [];
  let tenantOptions = [];

  // Find the country
  const defaultCountry = countries.find(
    (country) => country.countryCode === defaultCountryId,
  );

  // Populate country dropdown options
  countries.forEach((country) => {
    countryOptions.push({
      label: country.countryName,
      value: country.countryCode,
    });
  });

  // Populate tenant dropdown options based on the country
  const defaultTenants = defaultCountry ? defaultCountry.tenants : [];
  defaultTenants.forEach((tenant) => {
    tenantOptions.push({ label: tenant.tenantName, value: tenant.tenantId });
  });

  return { countryOptions, tenantOptions };
};

export const getPositions = (data) => {
  const positions = data?.tenants?.flatMap(tenant => {
    const {tenantName, tenantId} = tenant;
    tenant?.sites?.forEach(site => {
      const alertLevels = site.devices.flatMap(device => device.alerts.map(alert => alert.alertLevel));
      if(site.devices.length === 0 || site.devices[0].deviceName === null){
        site.siteStatus = SYSTEM_NOT_AVAILABLE;
      }else if(alertLevels.includes(2)){
        site.siteStatus = ALERT_LEVEL.CRITICAL;
      }else if(alertLevels.includes(1)){
        site.siteStatus = ALERT_LEVEL.WARNING;
      }else{
        site.siteStatus = ALERT_LEVEL.NORMAL;
      }
    });
    return tenant?.sites?.map(site => ({
        lat: site.latitude,
        lng: site.longitude,
        city: site.city,
        tenantName: tenantName,
        tenantId:tenantId,
        siteName:site.siteName,
        siteId:site.siteId,
        address: site.address,
        siteType: site.siteType,
        siteStatus: site.siteStatus,
        devices: site.devices,
        systems: site?.systems || [],
    }));
});
return positions;
};

export const getSitesForTenant = (filterData,countryCode, tenantId) => {
  const country = filterData.find((country) => country.countryCode === countryCode);
  const tenant = country?.tenants.find(
    (tenant) => tenant.tenantId === tenantId,
  );
  const sites =
    tenant?.sites.map((site) => ({
      label: site.siteName,
      value: site.siteId,
    })) || [];

  return sites;
};

export const getRefinedListData = (responseData, tenantsLength, sitesLength) => { 
  const extractedData = [];
    responseData.tenants.forEach(tenant => {
      const { tenantName } = tenant;
      tenant.sites.forEach(site => {
        const { siteName } = site;
        site.devices.forEach(device => {
          const { deviceName,deviceDescription, alerts } = device;

            let maxAlerts = alerts.splice(0,6);
            let deviceStatus; 
            // Determine device status based on the types of alerts present
            if(maxAlerts.length === ALERT_LEVEL.NORMAL_CODE){
              deviceStatus = ALERT_LEVEL.NORMAL;
            }else if (maxAlerts.every(alert => alert.alertLevel === ALERT_LEVEL.CRITICAL_CODE)) {
                deviceStatus = ALERT_LEVEL.CRITICAL;
            } else if (maxAlerts.every(alert => alert.alertLevel === ALERT_LEVEL.WARNING_CODE)) {
                deviceStatus = ALERT_LEVEL.WARNING;
            } else {
                deviceStatus = ALERT_LEVEL.CRITICAL_WARNING;
            }
          const deviceData = {
            tenantName,
            siteName,
            deviceName,
            deviceDescription,
            deviceStatus,
            tenantsLength : tenantsLength,
            sitesLength: sitesLength,
            alerts: maxAlerts.map(alert => ({
              alertLevel: alert.alertLevel,
              propertyName: alert.propertyName,
              alertName: alert.alertName,
              alertMessage: alert.alertMessage
            }))
          };
          extractedData.push(deviceData);
        });
      });
    });

  return extractedData;
};

export const statusData=[
  {
    label:"Critical",
    value:"critical"
  },
  {
    label:"Warning",
    value:"warning"
  },
  {
    label:"Normal",
    value:"normal"
  }
];